import { NavSection } from "src/components/layout/nav/nav-section";
import { Icon } from "src/components/layout/nav/icons/activation";
import { ActiveSectionProps } from "src/components/layout/nav/utils";
import { useAgenticHomeEnabled } from "src/hooks/use-agentic-home-enabled";
import { UseSectionHook } from "./types";

export const useActivateSection: UseSectionHook = () => {
  const dataOverviewEnabled = useAgenticHomeEnabled();

  return {
    title: "Activation",
    isEnabled: true,
    links: [
      dataOverviewEnabled && {
        href: "/data-overview",
        label: "Overview",
      },
      {
        href: "/syncs",
        label: "Syncs",
        activePaths: ["/realtime-syncs"],
      },
      {
        href: "/models",
        label: "Models",
      },
      {
        href: "/sequences",
        label: "Sequences",
      },
    ],
  };
};

export const Activate = (props: ActiveSectionProps) => {
  const section = useActivateSection();
  return <NavSection icon={Icon} {...section} {...props} />;
};
